// Icons exported from the careers Figma frame. Each SVG keeps the root width and
// height it was drawn at, so sizing is done by the design's own values rather
// than stretching the artwork.
import { ReactComponent as BriefcaseBusiness } from "./images/briefcase-business.svg";
import { ReactComponent as CheckCircle2 } from "./images/check-circle-2.svg";
import { ReactComponent as Chevron } from "./images/chevron.svg";
import { ReactComponent as Clock3 } from "./images/clock-3.svg";
import { ReactComponent as HeartHandshake } from "./images/heart-handshake.svg";
import { ReactComponent as MapPin } from "./images/map-pin.svg";
import { ReactComponent as Search } from "./images/search.svg";
import { ReactComponent as Settings } from "./images/settings.svg";
import { ReactComponent as Teams } from "./images/teams.svg";
import { ReactComponent as Tools } from "./images/tools.svg";
import { ReactComponent as Users } from "./images/users.svg";

export const benefitIcons = {
    heartHandshake: HeartHandshake,
    settings: Settings,
    tools: Tools,
    users: Users,
};

export {
    BriefcaseBusiness,
    CheckCircle2,
    Chevron,
    Clock3,
    MapPin,
    Search,
    Teams,
};
